import { lazy, Suspense, useEffect, useState } from 'react';
import { texts } from './i18n/index.ts';
import styles from './pages/Landing.module.css';

// Phaser + LiveKit erst laden, wenn ein Space geöffnet wird (kleinerer Start-Download)
const SpaceGate = lazy(() => import('./pages/SpaceGate.tsx').then((m) => ({ default: m.SpaceGate })));

/** Einfaches Routing: `/s/<slug>` = Space, sonst Startseite. */
function slugFromPath(pathname: string): string | undefined {
  const m = /^\/s\/([a-z0-9-]{1,64})\/?$/i.exec(pathname);
  return m?.[1]?.toLowerCase();
}

export function App() {
  const [path, setPath] = useState(() => window.location.pathname);
  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const slug = slugFromPath(path);
  if (slug) {
    return (
      <Suspense fallback={<main className={styles.landing}>{texts.space.loading}</main>}>
        <SpaceGate slug={slug} />
      </Suspense>
    );
  }
  return (
    <main className={styles.landing}>
      <img src="/favicon.svg" alt="" width={64} height={64} className={styles.logo} />
      <h1>{texts.app.name}</h1>
      <p className={styles.tagline}>{texts.app.tagline}</p>
      <p>{texts.app.noSpace}</p>
    </main>
  );
}
